export const triggerButtonClick = () => {
  // Find the button by its ID
  const button = document.getElementById("yourLibrary");

  // Check if the button exists and trigger the click event
  if (button) {
    button.click();
  } else {
    console.error("Button not found!");
  }
};
